function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M372.42,733.97c-6.19,0-12.4-.16-18.62-.48-94.7-4.86-181.83-46.31-245.36-116.7C44.93,546.39,12.62,455.47,17.48,360.77c4.86-94.7,46.31-181.83,116.7-245.35C204.58,51.9,295.5,19.59,390.2,24.45c94.7,4.86,181.83,46.31,245.36,116.7,63.52,70.4,95.83,161.32,90.97,256.01-4.86,94.7-46.31,181.83-116.7,245.36-65.77,59.35-149.45,91.45-237.39,91.45ZM371.62,60.94c-78.78,0-153.75,28.76-212.67,81.92-63.07,56.91-100.2,134.97-104.55,219.8-4.35,84.83,24.59,166.28,81.5,229.35,56.91,63.07,134.97,100.2,219.8,104.55,5.57.29,11.14.43,16.68.43,78.79,0,153.75-28.75,212.67-81.92,63.07-56.91,100.2-134.97,104.55-219.8,8.99-175.13-126.17-324.91-301.3-333.9h0c-5.58-.29-11.14-.43-16.68-.43Z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 224.63,
  cy: 374.33,
  r: 41.77
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 519.36,
  cy: 374.33,
  r: 41.77
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M373.7,572.13c67.91-.77,123.25-49.53,131.92-93.66,1.23-6.47-3.66-12.45-10.25-12.49h-243.35c-6.59.04-11.47,6.02-10.25,12.49,8.67,44.13,64.01,92.9,131.92,93.66Z"
});

var SvgMood5 = function SvgMood5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 750 750",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMood5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mood5.5ef84d2a.svg";
export { ForwardRef as ReactComponent };